import Vue from 'vue';
import { customAlphabet } from 'nanoid/non-secure';
import { alphanumeric } from 'nanoid-dictionary';

export const nanoid = customAlphabet(alphanumeric, 8);

export default Vue.extend({
  props: {
    uid: {
      type: String,
      default() {
        return nanoid();
      },
    },
  },
});
